import DashboardError from './DashboardError';
export default DashboardError;
